import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type { IApiGetAppResponseBody } from '../Apps';
import type { IApiWPPlaylistsResponseBody } from './WPPlaylistsApi.types';

export class WPPlaylistsApi {
  public constructor(private client: ApiClient) {}

  public async activate(appId: string): Promise<IApiGetAppResponseBody> {
    const request: IApiJsonRequest = {
      method: 'post',
      path: `/apps/${appId}/activateWPPlaylists`,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiGetAppResponseBody>(request);

    return data;
  }

  public async getAll(appId: string): Promise<IApiWPPlaylistsResponseBody> {
    const request: IApiJsonRequest = {
      method: 'get',
      path: `/apps/${appId}/wpPlaylists`,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiWPPlaylistsResponseBody>(
        request,
      );

    return data;
  }
}
